<template>
    <v-chip :color="ativo ? 'green' : 'red'" outlined>
      {{ ativo ? "Ativo" : "Inativo" }}
    </v-chip>
  </template>
  
  <script>
  export default {
    name: "AtivoInativoComponent",
    props: {
      ativo: {
        type: Boolean,
        default: false,
      },
    },
  };
  </script>